import { CheckCircleOutlined, DeleteOutlined } from '@ant-design/icons';
import { Button, Card, Image, Popconfirm, Tooltip } from 'antd';
import { cn } from 'cn';
import type { ImageListValue } from './ImageList';

export function ImageListImage({
    image,
    fotoPrincipalIdpk,
    setImageAsPrincipal,
    removeImage,
}: {
    image: ImageListValue;
    fotoPrincipalIdpk: string | undefined;
    setImageAsPrincipal: (image: ImageListValue) => void;
    removeImage: (idpk: string) => void;
}) {
    return (
        <Card
            className={cn(
                'h-48 w-[150px] shrink-0',
                image.idpk === fotoPrincipalIdpk && '!border-4 !border-primary',
            )}
            classNames={{ body: 'flex h-full flex-col items-center justify-center !p-4' }}
        >
            <Image className='object-contain' height={100} src={image.path} width={100} />

            <div className='mt-3 flex w-full items-center justify-center gap-1'>
                {image.idpk !== fotoPrincipalIdpk && (
                    <Tooltip color='black' placement='bottomLeft' title='Selecionar Principal'>
                        <Button
                            icon={<CheckCircleOutlined />}
                            onClick={() => setImageAsPrincipal(image)}
                        />
                    </Tooltip>
                )}

                <Popconfirm
                    cancelText='Não'
                    okText='Sim'
                    onConfirm={() => removeImage(image.idpk)}
                    title='Tem certeza que deseja apagar esta foto?'
                    zIndex={1050}
                >
                    <Button danger={true} icon={<DeleteOutlined />} />
                </Popconfirm>
            </div>
        </Card>
    );
}
